import { Mapper } from "../../../../base/utils/mapper";
import { PrescriptionResponseModel } from "../../../../domain/models/consult/prescription-response.model";
import { PrescriptionResponseEntity } from "../entities/prescription-response.entity";


export class PrescriptionImplementationRepositoryMapper extends Mapper<PrescriptionResponseEntity, PrescriptionResponseModel> {
    mapFrom(param: PrescriptionResponseEntity): PrescriptionResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: PrescriptionResponseModel): PrescriptionResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}